var HrCollection = class extends HTMLElement {
  constructor() {
    super();

    this.hrUrl = `https://core.helloretail.com/serve/pages/${window.theme.settings.helloretailPagesKey}`;
    const collectionHelloRetailPageKey = document.getElementById('collection-hello-retail-page-key')?.dataset.pageKey;
    if (collectionHelloRetailPageKey) {
      this.hrUrl = `https://core.helloretail.com/serve/pages/${collectionHelloRetailPageKey}`;
    }
    
    this.productPerPage = 48;
    this.defaultSort = ''; // leave blank. default will be popular - default HR sort method
    this.defaultSortsHideFromUrl = ['extraData.sortOnTitle asc'];
    if (window.theme.settings.collectionSort) {
      this.defaultSort = window.theme.settings.collectionSort;
      this.defaultSortsHideFromUrl = [window.theme.settings.collectionSort, 'extraData.sortOnTitle asc'];
    }
    this.isFirstLoad = true;
    this.selector = {
      productListWrapper: '.product-list',
      productEmpty: '.empty-state',
      pagination: '.hr-collection__pagination',
      productSke: '.hr-product-grid-skeleton product-card',
      filtersWrapper: '.facets__filters',
      filtersDrawer: '.facets-drawer .facets-vertical',
      filterListSke: '.hr-facet-list-ske',
      filterPriceSke: '.hr-facet-price-ske',
      filterPriceSkeOpen: '.hr-facet-price-ske[open]'
    };
    this.currentFilters = [];
    // check if URL have filters
    let url = new URL(window.location.href);
    let filters = url.searchParams.getAll('filters');
    if (filters.length) {
      this.currentFilters = filters;
    }
    this.currentSort = [];
    // check if URL have sorts
    let sorts = url.searchParams.getAll('sort');
    if (sorts.length) {
      this.currentSort = sorts;
    } else {
      if (!window.theme.settings.collectionSort) {
        if (window.theme.settings.helloretailPagesIsSaleCollection) {
          // set this as default sort for sale collection
          this.currentSort = ['extraData.PIMsort asc'];
          this.defaultSortsHideFromUrl = ['extraData.PIMsort asc'];
        } else {
          if (window.theme.settings.helloretailPagesIsNewCollection) {
            this.currentSort = ['created desc', 'extraData.sortOnTitle asc'];
            this.defaultSortsHideFromUrl = ['created desc', 'extraData.sortOnTitle asc'];
          } else {
            this.currentSort = ['created desc', 'extraData.sortOnTitle asc'];
            this.defaultSortsHideFromUrl = ['created desc', 'extraData.sortOnTitle asc'];
          }
        }
      } else {
        if (this.defaultSort != '') {
          this.currentSort = [this.defaultSort, 'extraData.sortOnTitle asc'];
        } else {
          this.currentSort = ['extraData.sortOnTitle asc'];
        }
      }
    }
    // check if URL have pagination
    this.page = 1;
    if (url.searchParams.get('page')) {
      this.page = parseInt(url.searchParams.get('page'));
    }
    if (window.theme.settings.helloretailPagesKey != '' && window.theme.settings.collectionUrl != '' && window.theme.settings.helloretailPagesEnabled) {
      this._request();
      this._paginationHandler();
      this._filterInputHandler();
      // this._filterSubmitHandler();
      this._sortingHandler();
      this._currentFacetHandler();
      this._showMoreHandler();
      this._searchHandler();
      this._mobileDrawerHandler();
      // this._sizeClickHandler();
      // this._customFilterListener();
    }

    // on popstate, reload to avoid issue with URL
    window.addEventListener('popstate', function(event) {
      location.reload();
    });
  }
  async _request(type = '') {
    if (!this.page && !this._isFetchingMoreProducts) {
      this.page = 1;
    }
    if (!this.isFirstLoad) {
      this.shouldScrollToTop = true;
    }

    this.updateOpeningFilters();

    function capitalizeFLetter(word) {
      return word[0].toUpperCase() + word.slice(1);
    }

    var collectionTitle = window.theme.settings.collectionTitle
    if (collectionTitle == 'SALE') {
      collectionTitle = capitalizeFLetter(collectionTitle.toLowerCase())
    }

    let queryParams = {
      'url': window.theme.settings.collectionUrl,
      'layout': true,
      'firstLoad': true,
      'trackingUserId': window.helloRetailTrackingUserId ? window.helloRetailTrackingUserId : '',
      'format': 'json',
      'params': {
        'filters': {
          'hierarchies':[collectionTitle]
        }
      },
      'products': {
        'start': this.productPerPage * (this.page - 1),
        'count': this.productPerPage,
        'fields':['title','url','productNumber','inStock','price','oldPrice', 'imgUrl', 'extraData.hoverImage', 'extraData.strictStringifiedVariantData', 'extraData.handle', 'extraData.publishedAt', 'extraData.feedPrice', 'extraData.feedCompareAtPrice','extraData.isFromPrice','extraDataList.badges', 'isBanner', 'bannerImages', 'productNumber', 'retailMediaCampaignId', 'trackingCode', 'extraData.suitableAsGift', 'extraDataList.giftOccasion'],
        "filters": [],
        'sorting': this.defaultSortsHideFromUrl
      }
    };
    if (window.theme.settings.helloretailCollectionQueryId) {
      queryParams.id = window.theme.settings.helloretailCollectionQueryId;
    }

    if (window.theme.settings.helloretailUseCollectionId && window.theme.settings.collectionId != '') {
      let specialCollectionId = '';
      let specialCollectionTitle = '';
      if (window.isNewVersionDynamicSubCollection) {
        // get special collection id from URL params special-collection
        specialCollectionId = new URL(window.location.href).searchParams.get('sc-id');
        specialCollectionTitle = new URL(window.location.href).searchParams.get('sc-name');
      }

      if (specialCollectionId) {
        queryParams.params.filters = {
          "$and": [
            {'extraDataList.collectionIds': window.theme.settings.collectionId},
            {'extraDataList.collectionIds': specialCollectionId}
          ]
        }
        if (specialCollectionTitle && this.isFirstLoad) {
          // decode special collection title from URL
          specialCollectionTitle = decodeURIComponent(specialCollectionTitle);
          if (document.querySelector('.collection-banner__heading')) {
            document.querySelector('.collection-banner__heading').innerHTML += `<span class="sc-badge">${specialCollectionTitle}<span class="remove-sc"><svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linejoin="round" aria-hidden="true" focusable="false" role="presentation" class="icon">
                <path d="M5 19 19 5M5 5l14 14"></path></svg></span></span>`;
          }
          document.querySelector('.remove-sc').addEventListener('click', function (e) {
            e.preventDefault();
            let currentUrl = new URL(window.location.href);
            currentUrl.searchParams.delete('sc-id');
            currentUrl.searchParams.delete('sc-name');
            window.location.href = currentUrl;
          });
        }
      } else {
        queryParams.params.filters = {'extraDataList.collectionIds': window.theme.settings.collectionId}
      }
    }

    queryParams.products.filters = this.currentFilters;

    if (this.currentSort.length) {
      if (this.currentSort[0] != 'most-popular') {
        queryParams.products.sorting = this.currentSort;
      } else {
        queryParams.products.sorting = []
      }
    }

    this.querySelector('.facets__footer button').classList.add('is-loading');
    this.querySelector('.facets__footer button').setAttribute('aria-busy', true);
    try {
      const response = await fetch(this.hrUrl, {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(queryParams),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      this.data = data;

      // 1. Get the product list from JSON data, then show on search grid
      this._renderProducts();

      // 2. render sidebar filters
      this._renderSidebarFilters('desktop');
      // this._renderSidebarFilters('mobile');

      // 3. render top bar
      this._renderTopBar();

      // scroll to top of this. Update: disable this since client want to keep the scroll position on desktop. Enable again for pagination change
      if (this.paginationChange) {
        if (document.querySelector('h1')) {
          document.querySelector('h1').scrollIntoView({ behavior: 'instant' });
        } else {
          this.scrollIntoView({ behavior: 'instant' });
        }
        this.paginationChange = false;
      }

      // 4. update filter from currentFilter to URL
      let url = new URL(window.location.href);
      if (!this.page || !this._isFetchingMoreProducts) {
        url.searchParams.delete('page');
      } else {
        url.searchParams.set('page', this.page);
      }
      // clear all filters from URL and build new one
      url.searchParams.delete('filters');
      this.currentFilters.forEach(function (item) {
        if (!url.searchParams.getAll('filters').includes(item)) {
          url.searchParams.append('filters', item);
        }
      });

      url.searchParams.delete('sort');
      if (this.currentSort.length) {
        this.currentSort.forEach(function (item) {
          // check if sort is default sort, then don't add to URL
          if (!this.defaultSortsHideFromUrl.includes(item)) {
            url.searchParams.append('sort', item);
          }
        }.bind(this));
      }
      url.searchParams.delete('page');
      if (this.page > 1) {
        url.searchParams.set('page', this.page);
      }
      // window.history.pushState({}, '', url);
      if (window.location.href !== url.toString()) {
        history.pushState(url, '', url);
      }
      this._isFetchingMoreProducts = false;

      // update pagination
      let pagination = this.querySelector(this.selector.pagination);
      if (this.numberOfPage > 1) {
        // pagination.querySelector('.pagination__current').innerText = `${this.page} / ${this.numberOfPage}`;
        pagination.querySelector('.pagination__current').innerHTML = `<span class="pagination-input"><span class="current-page">${this.page} / ${this.numberOfPage}</span><input type="number" min="1" max="${this.numberOfPage}" class="hidden" /></span>`;
        pagination.removeAttribute('hidden');
        pagination.querySelectorAll('.pagination__item').forEach(function (item) {
          item.classList.remove('loading');
        });

        let firstUrl = new URL(window.location.href);
        firstUrl.searchParams.delete('page');
        let lastUrl = new URL(window.location.href);
        lastUrl.searchParams.set('page', this.numberOfPage);
        let prevUrl = new URL(window.location.href);
        prevUrl.searchParams.set('page', this.page - 1);
        if (this.page - 1 <= 1) {
          prevUrl.searchParams.delete('page');
        }
        let nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('page', this.page + 1);

        if (this.page == 1) {
          pagination.querySelector('.pagination__item-prev').setAttribute('href', '#');
          pagination.querySelector('.pagination__item-prev').classList.add('disabled');
          pagination.querySelector('.pagination__item-first').setAttribute('href', '#');
          pagination.querySelector('.pagination__item-first').classList.add('disabled');

          pagination.querySelector('.pagination__item-next').setAttribute('href', nextUrl);
          pagination.querySelector('.pagination__item-next').classList.remove('disabled');
          pagination.querySelector('.pagination__item-last').setAttribute('href', lastUrl);
          pagination.querySelector('.pagination__item-last').classList.remove('disabled');
        } else if (this.page == this.numberOfPage) {
          pagination.querySelector('.pagination__item-next').setAttribute('href', '#');
          pagination.querySelector('.pagination__item-next').classList.add('disabled');
          pagination.querySelector('.pagination__item-last').setAttribute('href', '#');
          pagination.querySelector('.pagination__item-last').classList.add('disabled');

          pagination.querySelector('.pagination__item-prev').setAttribute('href', prevUrl);
          pagination.querySelector('.pagination__item-prev').classList.remove('disabled');
          pagination.querySelector('.pagination__item-first').setAttribute('href', firstUrl);
          pagination.querySelector('.pagination__item-first').classList.remove('disabled');
        } else {
          pagination.querySelector('.pagination__item-prev').setAttribute('href', prevUrl);
          pagination.querySelector('.pagination__item-next').setAttribute('href', nextUrl);
          pagination.querySelector('.pagination__item-first').setAttribute('href', firstUrl);
          pagination.querySelector('.pagination__item-last').setAttribute('href', lastUrl);

          pagination.querySelectorAll('.pagination__item').forEach(function (item) {
            item.classList.remove('disabled');
          });
        }
      } else {
        pagination.setAttribute('hidden', '');
      }

      if (window.isNewVersionDynamicSubCollection) {
        // Dynamic sub collection for grandchild collection in collection page
        if (window.currentCollectionHandle) {
          if (window.currentCollectionLevel == 'grandchild') {
            this.renderGrandchildSubCollection();
          }
        }
      }

    } catch (e) {
      // Handle errors
      console.error(e);
      this._isFetchingMoreProducts = false;
    } finally {
      this.querySelector('.facets__footer button').classList.remove('is-loading');
      this.querySelector('.facets__footer button').setAttribute('aria-busy', false);
    }
  }

  async _renderProducts() {
    let self = this;
    let selector = this.selector;
    let products = this.data.products.result;
    this.numberOfPage = Math.ceil(this.data.products.total / 48);
    let productListWrapper = this.querySelector(selector.productListWrapper);
    let currentDate = new Date();

    // console.log("products", products);

    if (products && products.length) {
      // hide empty message
      this.querySelector(selector.productEmpty).classList.add('hidden');
      if (this.querySelector(selector.productEmpty)) {
        const emptyStateDiv = this.querySelector('#empty-state-empty');
        if (emptyStateDiv) {
          emptyStateDiv.remove();
        }
      }
      

      // show product list wrapper
      productListWrapper.innerHTML = '';
      productListWrapper.classList.remove('hidden');

      // Iterate through products and add them to the list
      let imageSize = 560;
      if (window.innerWidth < 768) {
        imageSize = 370;
      }
      let collectionHandle = ''
      if (window.theme.settings.collectionUrl) {
        collectionHandle = window.theme.settings.collectionUrl.split('/').pop();
      }
      products.forEach(function(product, index) {
        let productSke = '';

        if (product.isBanner) {
          productSke = this.querySelector(selector.productSke).cloneNode(true);
        
          var bannerHTML = '<div class="hr-banner">';
          bannerHTML += '<a href="' + product.url + '" title="' + product.title + '">';

          var pagesDesktopImg = null;
          var pagesMobileImg = null;
          if (product.bannerImages.pagesDesktop) {
            pagesDesktopImg = product.bannerImages.pagesDesktop;
            pagesMobileImg = product.bannerImages.pagesDesktop;
          }
          if (product.bannerImages.pagesMobile) {
            pagesMobileImg = product.bannerImages.pagesMobile;
          }
          if (pagesDesktopImg) {
            bannerHTML += '<img class="desktop-only" src="' + pagesDesktopImg.url + '" alt="' + pagesDesktopImg.altText + '" width="' + pagesDesktopImg.width + '" height="' + pagesDesktopImg.height + '"/>'
          }
          if (pagesMobileImg) {
            bannerHTML += '<img class="mobile-only" src="' + pagesMobileImg.url + '" alt="' + pagesMobileImg.altText + '" width="' + pagesMobileImg.width + '" height="' + pagesMobileImg.height + '"/>'
          }

          bannerHTML += '</a>';
          bannerHTML += '</div>';

          productSke.innerHTML = bannerHTML;
        } else {
          productSke = this.querySelector(selector.productSke).cloneNode(true);
          var productUrl = product.url;
          if (productUrl.indexOf('luksusbaby.no') > -1) {
            productUrl = productUrl.replace('luksusbaby.no', window.location.host);
          } else if (productUrl.indexOf('luksusbaby.dk') > -1) {
            productUrl = productUrl.replace('luksusbaby.dk', window.location.host);
          }
          let productUrlWithCollection = productUrl;
          if (collectionHandle) {
            productUrlWithCollection = productUrl.replace('/products/', `/collections/${collectionHandle}/products/`);
          }

          let imageHtml = `<img src="${this.modifyImageUrl(product.imgUrl, imageSize)}" alt="${product.title}" ${index >= 4 ? 'loading="lazy"' : ''} class="img-fit card__main-image">`;
          let secondImage = product.imgUrl;
          if (product.extraData && product.extraData.hoverImage) {
            secondImage = product.extraData.hoverImage;
          }
          imageHtml += `<img src="${this.modifyImageUrl(secondImage, imageSize)}" alt="${product.title}" loading="lazy" class="img-fit card__hover-image" fetchpriority="low">`;
          productSke.querySelector('.card__media > a').innerHTML = imageHtml;

          productSke.querySelector('.card__media a').setAttribute('href', productUrlWithCollection);
          productSke.querySelector('.card__title a').innerText = product.title;

          productSke.querySelector('.card__title a').setAttribute('href', productUrlWithCollection);

          var price = parseFloat(product.extraData.feedPrice)
          var compareAtPrice = parseFloat(product.extraData.feedCompareAtPrice)

          let priceFormatted = self.formatMoney(price * 100, window.theme.settings.moneyFormat);
          if (product.extraData.isFromPrice == 'true') {
            priceFormatted = window.theme.strings.fromPrice + ' ' + priceFormatted;
          }

          let compareAtPriceFormatted = self.formatMoney(compareAtPrice * 100, window.theme.settings.moneyFormat);
          productSke.querySelector('.price__current').innerText = priceFormatted;
          if (price < compareAtPrice) {
            productSke.querySelector('.price').classList.add('price--on-sale');
            productSke.querySelector('.price__was').innerText = compareAtPriceFormatted;

            let salePercent = Math.round((compareAtPrice - price) / compareAtPrice * 100);
            if (salePercent > 0 && productSke.querySelector('.badge--on-sale')) {
              productSke.querySelector('.badge--on-sale .badge-text').innerText += ` ${salePercent}%`;
              productSke.querySelector('.badge--on-sale').classList.remove('hidden');
            }
          }

          if (!product.inStock && productSke.querySelector('.badge--sold-out')) {
            productSke.querySelector('.badge--sold-out').classList.remove('hidden');
          }

          // add new badge base on published date
          if (productSke.querySelector('.badge--new')) {
            let publishedDate = product.extraData.publishedAt // "2022-02-04T10:53:00+01:00"
            // check if publishedDate < 30 days ago
            let publishedDateObj = new Date(publishedDate);
            let diffTime = Math.abs(currentDate - publishedDateObj);
            let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            if (diffDays < 30) {
              productSke.querySelector('.badge--new').classList.remove('hidden');
            }
          }

          if (product.extraDataList && product.extraDataList.badges && product.extraDataList.badges.length && productSke.querySelector('.badge--custom')) {
            let badgeArr = [];
            product.extraDataList.badges.forEach(function (badge) {
              if (badge.indexOf('[') > -1 && badge.indexOf(']') > -1) {
                // parse array
                let parsedBadge = JSON.parse(badge);
                if (parsedBadge.length) {
                  badgeArr = badgeArr.concat(parsedBadge);
                }
              } else {
                badgeArr.push(badge);
              }
            });
            // unique badgeArr
            badgeArr = [...new Set(badgeArr)];
            badgeArr.forEach(function (badge) {
              let badgeHtml = `<div class="product-label-wrapper flex badge--new badge--custom">
                  <span class="product-label product-label--custom" data-text="${badge.toLowerCase()}">
                    <span class="badge-text">${badge}</span>
                  </span>
                </div>`;
              productSke.querySelector('.product-label-container').innerHTML += badgeHtml;
            });
          }

          productSke.querySelector('.card__quick-add .js-quick-add')?.setAttribute('data-product-url', productUrl);
          productSke.querySelector('.card__quick-add .quick-add-view-btn')?.setAttribute('href', productUrl);

          if (product.extraData?.strictStringifiedVariantData) {
            let variants = JSON.parse(product.extraData.strictStringifiedVariantData);

            if (variants && variants.length) {
              // sort variants by variant.title (size). Only sort if the title is digit. otherwise, keep default order
              variants.sort((a, b) => {
                let keyA = self.sizeSortKey(a.title, true);
                let keyB = self.sizeSortKey(b.title, true);

                if (keyA.category !== keyB.category) {
                  return keyA.category - keyB.category;
                } else if (keyA.value !== keyB.value) {
                  return keyA.value > keyB.value ? 1 : -1;
                }
                return 0;
              });

              let variantHtml = '';
              let isOnlyClass = variants.length == 1 ? 'is-only' : '';
              for (let i = 0; i < variants.length; i++) {
                if (variants[i].inventoryQuantity > 0) {
                  let parsedTitle = variants[i].title.replace(/"/g, '&quot;').replace(/'/g, "&#39;");
                  variantHtml += `<span class="product-card__size ${isOnlyClass}" data-title="${parsedTitle}">${variants[i].title}</span>`;
                }
              }
              productSke.querySelector('.product-card_sizes').innerHTML = `${variantHtml}`;

              if (variants.length == 1 && product.inStock) {
                let singleVariantId = variants[0].id.split('/').pop();
                if (singleVariantId) {
                  productSke.querySelector('.js-quick-add').setAttribute('data-variant-id', singleVariantId);
                  productSke.querySelector('.js-quick-add').classList.add('js-quick-add-variant');
                }
              }
            }
          }
        }

        // wrap productSke with a <li>
        var pro_handle = '';
        if (product.extraData && product.extraData.handle) {
          pro_handle = product.extraData.handle;
        }

        let productLi = document.createElement('li');
        productLi.appendChild(productSke);
        productLi.classList.add('product-card-li');
        productLi.setAttribute("data-handle", pro_handle);
        productListWrapper.appendChild(productLi);

        if (pro_handle) {
          this.getData(pro_handle);
        }
      }.bind(this));

      // render counter
      let counter = document.querySelector('.collection-banner__count');
      if (counter) {
        let countText = `${this.data.products.total} ${this.data.products.total > 1 ? window.theme.strings.products : window.theme.strings.product}`;
        counter.innerText = countText;
      }
    } else {
      // show empty message
      this.querySelector(selector.productEmpty).classList.remove('hidden');
      if (this.querySelector(selector.productEmpty)) {
        const noProductsDiv = this.querySelector(selector.productEmpty);
        noProductsDiv.classList.remove('hidden');
        
        // Check if empty-state-empty div already exists
        if (!noProductsDiv.querySelector('#empty-state-empty')) {
          const emptyStateDiv = document.createElement('div');
          emptyStateDiv.id = 'empty-state-empty';
          
          // Insert it inside the prose div if it exists, otherwise directly in noProductsDiv
          const proseDiv = noProductsDiv.querySelector('.prose');
          if (proseDiv) {
            proseDiv.insertBefore(emptyStateDiv, proseDiv.firstChild);
          } else {
            noProductsDiv.insertBefore(emptyStateDiv, noProductsDiv.firstChild);
          }
        }
      }
      productListWrapper.classList.add('hidden');
      this.numberOfPage = 0;
    }
  }

  async getData(handle) {
    const url = "https://luksusbaby.dk/products/" + handle + "?view=get-pro-meta";
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const result = await response.json();
      // console.log(result);
      if(parseInt(result) > 1) {
        var sel_product = document.querySelector(".product-card-li[data-handle='" + handle + "']");
        sel_product.querySelector(".more-color-badge").classList.remove("hidden");
      }
    } catch (error) {
      console.error(error.message);
    }
  }


  modifyImageUrl(imageUrl, width) {
    // Check if the URL is from Shopify's CDN
    if (imageUrl.includes("cdn.shopify.com")) {
      // Construct the new URL with the desired size
      let newUrl = imageUrl.split('?')[0].replace(/(\.[^.]*)$/, `_${width}x${width}$1`) + '?' + imageUrl.split('?')[1];
      return newUrl;
    }
  }

  async _renderSidebarFilters(type) {
    const collectionTemplateName = document.getElementById('collection-template-name')?.dataset.template;

    let originalFilters = this.data.products?.filters;
    if (!originalFilters) {
      return;
    }
    let newFilters = originalFilters.filter(function (item) {
      // return !(item.name.indexOf('extraDataList.category') == 0);
      return item
    });
    if (newFilters.length) {
      let self = this;
      // let data = self.data;
      let selector = self.selector;
      let filtersWrapper = self.querySelector(selector.filtersWrapper);
      // let filtersDrawer = document.querySelector(selector.filtersDrawer);
      if (type == 'desktop') {
        filtersWrapper.innerHTML = '';
      } else if (type == 'mobile') {
        // filtersDrawer.querySelectorAll('[data-hr-facet]').forEach(function (item) {
        //   item.remove();
        // });
      }

      let currentFilterHtml = '';
      let currentFilterCount = 0;
      let filterOrder = [
        'extraDataList.shopBy',
        'extraDataList.gender',
        'extraDataList.PIMSizeAgeAgeList',
        'brand',
        'extraDataList.PIMSizeSizeList',
        'extraData.productType',
        'extraDataList.ProductFilterFilterText',
        'extraDataList.type',
        'extraDataList.categoryByType',
        'price',
        'extraData.shoeWidth'
      ]

      if (collectionTemplateName == 'giftfinder') {
        filterOrder = [
          'price'
        ]
      } else {
        filterOrder = []
      }
      
      // sort newFilters by filterOrder, if any filter inside newFilters is not in filterOrder, then push it to the end
      newFilters.sort((a, b) => {
        let keyA = filterOrder.indexOf(a.name);
        let keyB = filterOrder.indexOf(b.name);
        if (keyA === -1) {
          keyA = filterOrder.length;
        }
        if (keyB === -1) {
          keyB = filterOrder.length;
        }
        return keyA - keyB;
      });

      const sizeAgeFilterKeys = [
        'extraDataList.sizeShoes',
        'extraDataList.sizeClothes',
        'extraDataList.sizeFootwear',
        'extraDataList.sizeHeadgear',
        'extraDataList.sizeAccessories'
      ];

      const sizeAgeFilters = newFilters.filter(filter => sizeAgeFilterKeys.includes(filter.name));
      if (window.theme.settings.helloretailGroupedSizeAgeFilter && sizeAgeFilters.length > 0) {
        const firstSizeAgeFilterIndex = newFilters.findIndex(filter => sizeAgeFilterKeys.includes(filter.name));
        newFilters = newFilters.filter(filter => !sizeAgeFilterKeys.includes(filter.name));
        newFilters.splice(firstSizeAgeFilterIndex, 0, {
          name: 'sizeAgeGroup',
          _isSizeAgeGroup: true,
          _subFilters: sizeAgeFilters,
          settings: {
            type: 'LIST',
            title: window.theme.strings.sizeAgeFilterTitle || 'Storlek',
            name: 'sizeAgeGroup'
          }
        });
      }

      for (let i = 0; i < newFilters.length; i++) {
        let filter = newFilters[i];
        if (filter.settings && filter.settings.type === 'LIST') {
          if (filter._isSizeAgeGroup) {
            let filterSke = self.querySelector(selector.filterListSke).cloneNode(true);
            const sizeAgeFacetKeys = filter._subFilters.map(subFilter => subFilter.name);
            const sizeAgeFilterGroups = window.theme.settings.helloretailSizeAgeFilterGroups || [];
            const sizeAgeValueCount = filter._subFilters.reduce((total, subFilter) => total + subFilter.values.length, 0);
            const searchFilterList = window.theme.settings.helloretailSearchOnFilterList || [];
            const shouldShowSearch = searchFilterList.includes(filter.name)
              || sizeAgeFacetKeys.some(key => searchFilterList.includes(key))
              || searchFilterList.includes('extraDataList.PIMSizeAgeAgeList')
              || searchFilterList.includes('extraDataList.PIMSizeSizeList');
            const hasMultipleSizeAgeGroups = filter._subFilters.length > 1;

            if (filter.name == window.currentHrFacet) {
              if (self.isFirstLoad) {
                filterSke.querySelector('.filter.disclosure').setAttribute('open', '');
              }
            }
            filterSke.classList.remove('hr-facet-list-ske');
            filterSke.setAttribute('data-hr-facet', filter.name);
            filterSke.setAttribute('data-hr-facet-keys', JSON.stringify(sizeAgeFacetKeys));

            let checkboxList = filterSke.querySelector('.filter__content .checkbox-list');
            checkboxList.innerHTML = '';

            filter._subFilters.forEach((subFilter, subFilterIndex) => {
              subFilter.values.sort((a, b) => {
                let keyA = self.sizeSortKey(a.title);
                let keyB = self.sizeSortKey(b.title);

                if (keyA.category !== keyB.category) {
                  return keyA.category - keyB.category;
                } else if (keyA.value !== keyB.value) {
                  return keyA.value > keyB.value ? 1 : -1;
                }
                return 0;
              });

              const sizeAgeFilterGroup = sizeAgeFilterGroups.find(group => group.filterkey === subFilter.name);
              const groupTitle = sizeAgeFilterGroup?.frontend_label || subFilter.settings?.title || sizeAgeFilterGroup?.groupname || '';
              if (!hasMultipleSizeAgeGroups && subFilterIndex == 0) {
                filterSke.querySelector('.hr-facet-title').innerText = groupTitle || filter.settings?.title;
              }
              if (hasMultipleSizeAgeGroups) {
                if (groupTitle) {
                  checkboxList.innerHTML += `<summary class="filter__title" data-size-age-group-index="${subFilterIndex}">${groupTitle}</summary>`;
                }
              }

              for (let j = 0; j < subFilter.values.length; j++) {
                let value = subFilter.values[j];
                let valueTitle = value.title;
                const id = `hr-${subFilter.name}-${type}-${subFilterIndex}-${j}`;
                window.currentSizeAgeShowMoreGroups = window.currentSizeAgeShowMoreGroups || [];
                const isSizeAgeGroupExpanded = window.currentSizeAgeShowMoreGroups.includes(subFilter.name);
                const isHiddenSizeAgeValue = hasMultipleSizeAgeGroups && !isSizeAgeGroupExpanded && j >= 5;
                let valueHtml = `<li data-size-age-group-index="${subFilterIndex}" ${isHiddenSizeAgeValue ? 'class="hidden size-age-group-extra"' : ''}>
                    <input type="checkbox" class="checkbox visually-hidden focus-label-before" id="${id}" name="hr-${subFilter.name}" value="${value.query}" ${value.selected ? 'checked' : ''}>
                    <label for="${id}" class="filter__label flex items-start w-full m-0">
                      <span class="filter__title">${valueTitle}</span>
                      <span class="filter__count">(${value.count})</span></label>
                  </li>`;

                checkboxList.innerHTML += valueHtml;

                if (value.selected) {
                  currentFilterHtml += `<a href="#" class="active-filter flex items-center text-current" data-instant="" value="${value.query}" data-filter-name="${subFilter.name}">
                    <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linejoin="round" aria-hidden="true" focusable="false" role="presentation" class="icon">
                    <path d="M5 19 19 5M5 5l14 14"></path></svg>${valueTitle}</a>`;
                  currentFilterCount += 1;
                }
              }

              if (hasMultipleSizeAgeGroups && subFilter.values.length > 5) {
                const showMoreText = filterSke.querySelector('.facet-show-more')?.innerHTML || 'See more';
                const showLessText = filterSke.querySelector('.facet-show-less')?.innerHTML || 'See less';
                const isSizeAgeGroupExpanded = window.currentSizeAgeShowMoreGroups.includes(subFilter.name);
                checkboxList.innerHTML += `<a href="#" class="size-age-group-show-more underline ${isSizeAgeGroupExpanded ? 'hidden' : ''}" data-size-age-group-index="${subFilterIndex}" data-size-age-filter-key="${subFilter.name}">${showMoreText}</a>`;
                checkboxList.innerHTML += `<a href="#" class="size-age-group-show-less underline ${isSizeAgeGroupExpanded ? '' : 'hidden'}" data-size-age-group-index="${subFilterIndex}" data-size-age-filter-key="${subFilter.name}">${showLessText}</a>`;
              }
            });

            if (!hasMultipleSizeAgeGroups && sizeAgeValueCount > window.theme.settings.helloretailShowMoreOnFilterList) {
              if (filterSke.querySelector('.facet-show-more')) {
                window.currentShowMoreTabs = window.currentShowMoreTabs || [];
                if (!window.currentShowMoreTabs.includes(filter.name)) {
                  filterSke.querySelector('.facet-show-more').classList.remove('hidden');
                  filterSke.querySelector('.checkbox-list').classList.add('short-list');
                } else {
                  filterSke.querySelector('.facet-show-less').classList.remove('hidden');
                  filterSke.querySelector('.checkbox-list').classList.remove('short-list');
                }
                if (window.innerWidth >= 768) {
                  if (this.isFirstLoad) {
                    filterSke.querySelector('details.filter').setAttribute('open', '');
                  }
                }
              }
            }

            if (hasMultipleSizeAgeGroups) {
              filterSke.querySelector('.hr-facet-title').innerText = filter.settings?.title;
            }

            if (shouldShowSearch && filterSke.querySelector('.facet-search')) {
              filterSke.querySelector('.facet-search').classList.remove('hidden');

              const clearButton = filterSke.querySelector('.facet-search-clear');
              if (clearButton) {
                clearButton.addEventListener('click', (event) => {
                  const searchInput = filterSke.querySelector('.facet-search');
                  searchInput.value = "";
                  const inputEvent = new Event('input', {
                    bubbles: true,
                    cancelable: true
                  });
                  searchInput.dispatchEvent(inputEvent);
                });

                clearButton.classList.remove('hidden');
              }
            }

            if (window.innerWidth >= 768 && shouldShowSearch && self.isFirstLoad) {
              filterSke.querySelector('details.filter').setAttribute('open', '');
            }

            if (collectionTemplateName == 'giftfinder') {
              filterSke.querySelector('.filter.disclosure').setAttribute('open', '');
            }

            if (this.mobileOpeningFilters.includes(filter.name)) {
              filterSke.querySelector('details.filter').setAttribute('open', '');
            }

            if (sizeAgeValueCount > 10) {
              filterSke.querySelector('.filter__content .hr-filter-search')?.classList.remove('hidden');
            }

            if (type == 'desktop') {
              filtersWrapper.appendChild(filterSke);
            } else if (type == 'mobile') {
              // filtersDrawer.appendChild(filterSke);
            }

            continue;
          }

          if (filter.settings.name == 'extraDataList.PIMSizeSizeList') {
            // sort filter values by XXXS, XXS, XS, S, M, L, XL, XXL, XXXL, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9..
            filter.values.sort((a, b) => {
              let keyA = self.sizeSortKey(a.title);
              let keyB = self.sizeSortKey(b.title);

              if (keyA.category !== keyB.category) {
                return keyA.category - keyB.category;
              } else if (keyA.value !== keyB.value) {
                return keyA.value > keyB.value ? 1 : -1;
              }
              return 0;
            });
          } else if (filter.settings.name == 'extraDataList.PIMSizeAgeAgeList') {

            const config = {
              monthUnit: window.theme.strings.helloretailMonthUnit || "mdr",
              yearUnit: window.theme.strings.helloretailYearUnit || "år",
              firstItem: window.theme.strings.helloretailFirstItem || "Præmature",
              lastItem: window.theme.strings.helloretailLastItem || "Voksen"
            };

            filter.values.sort((a, b) => {
              const aTitle = a.title
              const bTitle = b.title
                if (aTitle === config.firstItem) return -1;
                if (bTitle === config.firstItem) return 1;
                if (aTitle === config.lastItem) return 1;
                if (bTitle === config.lastItem) return -1;

                let aValue = parseInt(aTitle, 10);
                let bValue = parseInt(bTitle, 10);
                let aUnit = aTitle.indexOf(config.monthUnit) > -1 ? config.monthUnit : config.yearUnit;
                let bUnit = bTitle.indexOf(config.monthUnit) > -1 ? config.monthUnit : config.yearUnit;

                if (aUnit === bUnit) {
                    return aValue - bValue;
                }
                return aUnit === config.monthUnit ? -1 : 1;
            });
          } else if (filter.settings.name != 'extraDataList.availability') {
            // sort filter values by alphabet
            filter.values.sort(function(a, b) {
              let titleA = a.title.toUpperCase();
              let titleB = b.title.toUpperCase();
              if (titleA < titleB) {
                return -1;
              }
              if (titleA > titleB) {
                return 1;
              }
              return 0;
            });
          }

          let filterSke = self.querySelector(selector.filterListSke).cloneNode(true);
          if (filter.name == window.currentHrFacet) {
            if (self.isFirstLoad) {
              filterSke.querySelector('.filter.disclosure').setAttribute('open', '');
            }
          }
          filterSke.classList.remove('hr-facet-list-ske');
          filterSke.setAttribute('data-hr-facet', filter.name);
          filterSke.querySelector('.hr-facet-title').innerText = filter.settings?.title;

          let checkboxList = filterSke.querySelector('.filter__content .checkbox-list');
          if (filter.name == 'extraDataList.categoryByType') {
            checkboxList.classList.add('category-by-type');
          } else if (filter.name == 'extraDataList.hierarchy') {
            checkboxList.classList.add('hierarchy');
          } else if (filter.name == 'extraDataList.recommendedAge') {
            checkboxList.classList.add('recommended-age');
          }

          if (filter.name == 'extraDataList.primaryColor' && window.theme.settings.helloretailColorSwatches && window.theme.settings.helloretailColorSwatches.length) {
            if (window.theme.settings.helloretailColorSwatchesType == 'swatches') {
              checkboxList.classList.add('color-swatch-list');
            } else {
              checkboxList.classList.add('color-swatch-list-text');
            }
          }

          if (collectionTemplateName == 'giftfinder' && filter.name == 'extraDataList.hierarchy' && window.theme.settings.helloretailGiftfinderCollectionFilterList && window.theme.settings.helloretailGiftfinderCollectionFilterList.length) {
            const acceptedCollectionNames = window.theme.settings.helloretailGiftfinderCollectionFilterList;
            filter.values = filter.values.filter(value => {
              return acceptedCollectionNames.includes(value.title);
            });
          }

          for (let j = 0; j < filter.values.length; j++) {
            let value = filter.values[j];
            let valueTitle = value.title;

            // hide location, setting: Theme settings > Location > Hide locations
            if (filter.settings.name == 'extraDataList.availability' && window.theme.hide_locations != '') {
              const hideLocations = window.theme.hide_locations.split(',');
              if (hideLocations.includes(valueTitle)) {
                continue;
              }
            }

            if (filter.name == 'hierarchies') {
              // remove last character of title if it is $
              if (valueTitle.slice(-1) == '$') {
                valueTitle = valueTitle.slice(0, -1);
              }
            }
            let valueHtml = `<li style="order: -${value.count}">
                <input type="checkbox" class="checkbox visually-hidden focus-label-before" id="hr-${filter.name}-${type}-${j}" name="hr-${filter.name}" value="${value.query}" ${value.selected ? 'checked' : ''}>
                <label for="hr-${filter.name}-${type}-${j}" class="filter__label flex items-start w-full m-0">
                  <span class="filter__title">${valueTitle}</span>
                  <span class="filter__count">(${value.count})</span></label>
              </li>`;

            if (filter.name == 'extraDataList.primaryColor' && window.theme.settings.helloretailColorSwatches && window.theme.settings.helloretailColorSwatches.length) {
              let colorSwatch = '#ffffff';
              window.theme.settings.helloretailColorSwatches.forEach(function (color) {
                let colorTitle = color.split(':')[0];
                if (colorTitle.toLowerCase() == valueTitle.toLowerCase()) {
                  colorSwatch = color.split(':')[1];
                }
              });
              if (window.theme.settings.helloretailColorSwatchesType == 'swatches') {
                valueHtml = `<li style="order: -${value.count}" class="hr-color-swatch">
                  <input type="checkbox" class="checkbox visually-hidden focus-label-before" id="hr-${filter.name}-${type}-${j}" name="hr-${filter.name}" value="${value.query}" ${value.selected ? 'checked' : ''}>
                  <label for="hr-${filter.name}-${type}-${j}" class="filter__label flex items-start w-full m-0" title="${valueTitle} (${value.count})">
                    <span class="filter__title filter__title-color" style="background:${colorSwatch}"><span>${valueTitle}</span></span>
                    <span class="filter__count">(${value.count})</span></label>
                </li>`;
              } else {
                valueHtml = `<li style="order: -${value.count}">
                  <input type="checkbox" class="checkbox visually-hidden focus-label-before" id="hr-${filter.name}-${type}-${j}" name="hr-${filter.name}" value="${value.query}" ${value.selected ? 'checked' : ''}>
                  <label for="hr-${filter.name}-${type}-${j}" class="filter__label flex items-start w-full m-0">
                    <span class="filter__color" style="background:${colorSwatch}"></span>
                    <span class="filter__title">${valueTitle}</span>
                    <span class="filter__count">(${value.count})</span></label>
                </li>`;
              }
            }

            checkboxList.innerHTML += valueHtml;

            if (value.selected) {
              if (value.query.indexOf('extraDataList.categoryByType:') > -1 && valueTitle.indexOf('|') > -1) {
                valueTitle = valueTitle.split('|')[1];
              }
              currentFilterHtml += `<a href="#" class="active-filter flex items-center text-current" data-instant="" value="${value.query}" data-filter-name="${filter.name}">
                <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linejoin="round" aria-hidden="true" focusable="false" role="presentation" class="icon">
                <path d="M5 19 19 5M5 5l14 14"></path></svg>${valueTitle}</a>`;
              currentFilterCount += 1;
            }
          }

          if (filter.name == 'extraDataList.categoryByType' && window.theme.settings.helloretailGroupCategory) {
            // group filter values by parent collection
            let parentCollectionTree = {};
            if (filter.values.length) {
              filter.values.forEach(function (value) {
                if (value.title.indexOf('|') > 0) {
                  let groupTitle = value.title.split('|')[0].trim();
                  if (!parentCollectionTree[groupTitle]) {
                    parentCollectionTree[groupTitle] = [];
                  }
                  parentCollectionTree[groupTitle].push(value.title);
                }
              });
            }
            if (parentCollectionTree != {}) {
              // loop all filter values
              let valuesGrouped = {'uncategory': []};
              filter.values.forEach(function (value) {
                let found = false;
                for (let key in parentCollectionTree) {
                  if (parentCollectionTree[key].includes(value.title)) {
                    if (!valuesGrouped[key]) {
                      valuesGrouped[key] = [];
                    }
                    valuesGrouped[key].push(value);
                    found = true;
                  }
                }
                if (!found) {
                  if (!valuesGrouped['uncategory']) {
                    valuesGrouped['uncategory'] = [];
                  }
                  valuesGrouped['uncategory'].push(value);
                }
              });
              if (Object.keys(valuesGrouped).length) {
                let addedFilters = [];
                filterSke.querySelector('.filter__content .checkbox-list').innerHTML = '';
                // push empty group to the end of object
                if (valuesGrouped['uncategory']) {
                  valuesGrouped['--'] = [];
                  valuesGrouped['uncategory'].forEach(function (value) {
                    valuesGrouped['--'].push(value);
                  });
                  delete valuesGrouped['uncategory'];
                }
                // if valuesGrouped['--'] is empty, remove it
                if (valuesGrouped['--'].length == 0) {
                  delete valuesGrouped['--'];
                }
                for (let key in valuesGrouped) {
                  let groupHtml = `<summary class="filter__title">${key}</summary>`;
                  filterSke.querySelector('.filter__content .checkbox-list').innerHTML += groupHtml;
                  valuesGrouped[key].forEach(function (value) {
                    if (!addedFilters.includes(value)) {
                      addedFilters.push(value);
                      let valueHtml = `<li style="order: -${value.count}">
                          <input type="checkbox" class="checkbox visually-hidden focus-label-before" id="hr-${filter.name}-${type}-${value.query}" name="hr-${filter.name}" value="${value.query}" ${value.selected ? 'checked' : ''}>
                          <label for="hr-${filter.name}-${type}-${value.query}" class="filter__label flex items-start w-full m-0">
                            <span class="filter__title">${value.title.split('|')[1]}</span>
                            <span class="filter__count">(${value.count})</span></label>
                        </li>`;
                      filterSke.querySelector('.filter__content .checkbox-list').innerHTML += valueHtml;
                    }
                  });
                }
              }
            }
          }

          if (filter.values.length > window.theme.settings.helloretailShowMoreOnFilterList && (filter.name != 'extraDataList.primaryColor' || (filter.name == 'extraDataList.primaryColor' && window.theme.settings.helloretailColorSwatchesType != 'swatches'))) {
            // show Show more button
            if (filterSke.querySelector('.facet-show-more')) {
              window.currentShowMoreTabs = window.currentShowMoreTabs || [];
              if (!window.currentShowMoreTabs.includes(filter.name)) {
                filterSke.querySelector('.facet-show-more').classList.remove('hidden');
                filterSke.querySelector('.checkbox-list').classList.add('short-list');
              } else {
                filterSke.querySelector('.facet-show-less').classList.remove('hidden');
                filterSke.querySelector('.checkbox-list').classList.remove('short-list');
              }
              if (window.innerWidth >= 768) {
                if (this.isFirstLoad) {
                  filterSke.querySelector('details.filter').setAttribute('open', '');
                }
              }

              if (filter.name != 'extraDataList.PIMSizeAgeAgeList' && filter.name != 'extraDataList.PIMSizeSizeList') {
                const listItems = filterSke.querySelectorAll('.checkbox-list li');

                // Convert NodeList to an array and sort based on the 'order' attribute
                const sortedItems = Array.from(listItems).sort((a, b) => {
                  return parseInt(a.style.order) - parseInt(b.style.order);
                });

                // Select the first X items
                const firstXItems = sortedItems.slice(0, window.theme.settings.helloretailShowMoreOnFilterList);

                // Add a class or apply changes to the first 10 items
                firstXItems.forEach(item => {
                  item.classList.add('first-x');
                });
                filterSke.querySelector('.checkbox-list').classList.add('show-x-only');
              }
            }

            // show search input on filter list
            if (window.theme.settings.helloretailSearchOnFilterList && window.theme.settings.helloretailSearchOnFilterList.length) {
              if (window.theme.settings.helloretailSearchOnFilterList.includes(filter.name) && filterSke.querySelector('.facet-search')) {
                filterSke.querySelector('.facet-search').classList.remove('hidden');

                const clearButton = filterSke.querySelector('.facet-search-clear');
                if (clearButton) {
                  clearButton.addEventListener('click', (event) => {
                    const searchInput = filterSke.querySelector('.facet-search');
                    searchInput.value = "";
                    const inputEvent = new Event('input', {
                        bubbles: true,
                        cancelable: true
                    });
                    searchInput.dispatchEvent(inputEvent);
                  });
                  
                  clearButton.classList.remove('hidden');
                }
              }
            }
          }
          if (window.innerWidth >= 768 && window.theme.settings.helloretailSearchOnFilterList && window.theme.settings.helloretailSearchOnFilterList.length && self.isFirstLoad) {
            if (window.theme.settings.helloretailSearchOnFilterList.includes(filter.name) || filter.name == 'extraDataList.gender' || filter.name == 'extraDataList.shopBy') {
              filterSke.querySelector('details.filter').setAttribute('open', '');
            }
          }

          if (collectionTemplateName == 'giftfinder') {
            filterSke.querySelector('.filter.disclosure').setAttribute('open', '');
          }

          // if (window.innerWidth < 768) {
            if (this.mobileOpeningFilters.includes(filter.name)) {
              filterSke.querySelector('details.filter').setAttribute('open', '');
            }
          // }

          if (filter.values.length > 10) {
            filterSke.querySelector('.filter__content .hr-filter-search')?.classList.remove('hidden');
          }

          if (type == 'desktop') {
            filtersWrapper.appendChild(filterSke);
          } else if (type == 'mobile') {
            // filtersDrawer.appendChild(filterSke);
          }
        } else if (filter.name === 'price') {
          let priceSke = self.querySelector(selector.filterPriceSke).cloneNode(true);
          if (filter.name == window.currentHrFacet) {
            priceSke.querySelector('.filter.disclosure').setAttribute('open', '');
          }
          // if (window.innerWidth < 768) {
            if (this.mobileOpeningFilters.includes(filter.name)) {
              priceSke.querySelector('.filter.disclosure').setAttribute('open', '');
            }
          // }

          if (collectionTemplateName == 'giftfinder') {
            priceSke.querySelector('.filter.disclosure').setAttribute('open', '');
          }

          priceSke.classList.remove('hr-facet-price-ske');
          priceSke.setAttribute('data-hr-facet', filter.name);
          priceSke.querySelector('.hr-facet-title').innerText = filter.settings?.title;
          let minPrice = Math.floor(parseFloat(filter.min));
          let maxPrice = Math.ceil(parseFloat(filter.max));
          let selectedMin = 0;
          let selectedMax = maxPrice;
          if (filter.selectedMin) {
            selectedMin = Math.floor(parseFloat(filter.selectedMin));
          }
          if (filter.selectedMax) {
            selectedMax = Math.ceil(parseFloat(filter.selectedMax));
          }

          priceSke.querySelector('.range-min').setAttribute('max', maxPrice);
          priceSke.querySelector('.range-min').setAttribute('value', selectedMin);
          priceSke.querySelector('.range-max').setAttribute('max', maxPrice);
          priceSke.querySelector('.range-max').setAttribute('value', selectedMax);
          priceSke.querySelector('.field-price-min').setAttribute('max', maxPrice);
          priceSke.querySelector('.field-price-min').setAttribute('value', selectedMin);
          priceSke.querySelector('.field-price-min').setAttribute('placeholder', 0);
          priceSke.querySelector('.field-price-max').setAttribute('max', maxPrice);
          priceSke.querySelector('.field-price-max').setAttribute('value', selectedMax);
          priceSke.querySelector('.field-price-max').setAttribute('placeholder', maxPrice);

          if (type == 'desktop') {
            filtersWrapper.appendChild(priceSke);
          } else if (type == 'mobile') {
            // filtersDrawer.appendChild(priceSke);
          }

          if (selectedMin > 0 || selectedMax < maxPrice) {
            currentFilterHtml += `<a href="#" class="active-filter flex items-center text-current" data-instant="" data-filter-name="price">
                <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linejoin="round" aria-hidden="true" focusable="false" role="presentation" class="icon">
                <path d="M5 19 19 5M5 5l14 14"></path></svg>${self.formatMoney(selectedMin * 100, window.theme.settings.moneyFormat)} - ${self.formatMoney(selectedMax * 100, window.theme.settings.moneyFormat)}</a>`;
            currentFilterCount += 1;
          }
        }
      }

      let activeFacets = this.querySelector('.facets__active-filters');
      if (activeFacets) {
        activeFacets.querySelectorAll('.active-filter').forEach(function (item) {
          item.remove();
        });

        if (currentFilterHtml) {
          activeFacets.querySelector('.active-filters').innerHTML = currentFilterHtml;
          activeFacets.querySelector('.active-filters-header').innerText = activeFacets.querySelector('.active-filters-header').getAttribute('data-active-title') + ' (' + currentFilterCount + ')';
          activeFacets.querySelector('.active-filters-header').classList.add('active')
          // activeFacets.querySelector('details.disclosure').setAttribute('open', '');
          if (window.innerWidth >= 768) {
            activeFacets.querySelector('details.disclosure').removeAttribute('open');
          } else {
            if (this.isFirstLoad) {
              activeFacets.querySelector('details.disclosure').setAttribute('open', '');
            }
          }
          // activeFacets.removeAttribute('hidden');
        } else {
          activeFacets.querySelector('.active-filters-header').innerText = activeFacets.querySelector('.active-filters-header').getAttribute('data-empty-title');
          activeFacets.querySelector('details.disclosure').removeAttribute('open');
          activeFacets.querySelector('.active-filters-header').classList.remove('active')
          // activeFacets.setAttribute('hidden', '');
        }
      }

      // check if there are any option is filtering then show badge
      let currentTotal = this.data.products.total;
      if (currentFilterCount > 0) {
        document.querySelector('.hr-mobile-filter-counter').innerText = ` (${currentFilterCount})`;
      } else {
        document.querySelector('.hr-mobile-filter-counter').innerText = '';
      }
      if (currentTotal > 0) {
        document.querySelector('.facets__footer .filter-count').innerText = ` (${currentTotal})`;
      } else {
        document.querySelector('.facets__footer .filter-count').innerText = '';
      }
      document.querySelector('.facets__footer button').setAttribute('aria-busy', false);

      // prevent jump to top when click on filter mobile
      if (window.innerWidth < 768) {
        if (this.mobileFilterScroll > 0) {
          this.querySelector('.main-products-grid__filters .drawer__content').scrollTop = this.mobileFilterScroll;
        }
      }

      // trigger filter again current search
      if (window.currentCollectionHrSearchValue && window.currentCollectionHrContainer) {
        if (document.querySelector(`[data-hr-facet="${window.currentCollectionHrContainer}"] input.facet-search`)) {
          document.querySelector(`[data-hr-facet="${window.currentCollectionHrContainer}"] input.facet-search`).value = window.currentCollectionHrSearchValue;
          // trigger change event
          let event = new Event('input', {
            bubbles: true,
            cancelable: true,
          });
          document.querySelector(`[data-hr-facet="${window.currentCollectionHrContainer}"] input.facet-search`).dispatchEvent(event);
        }
      }

      // open the filter on mobile on page loads if the collection template is giftfinder
      if (window.innerWidth <= 768 && collectionTemplateName == 'giftfinder') {
        const productsToolbarFilterBtn = document.querySelector('.products-toolbar__filter-btn');
        if (productsToolbarFilterBtn) {
          productsToolbarFilterBtn.click();
        }
      }

      // FACET CLEAR - check to show "clear all" button
      const hrFacetElements = document.querySelectorAll('[data-hr-facet]');
      hrFacetElements.forEach(function (hrFacetElement) {
        const hrFacetClear = hrFacetElement.querySelector('.facet-clear');
        if (hrFacetClear) {
          const checkedInputs = hrFacetElement.querySelectorAll('input[type="checkbox"]:checked');
          if (checkedInputs.length) {
            const dataHrFacet = hrFacetElement.getAttribute('data-hr-facet');
            if (dataHrFacet == 'extraDataList.categoryByType' || dataHrFacet == 'sizeAgeGroup') {
              hrFacetClear.classList.remove('hidden');
            }
          }
        }
      });
    }
  }

  _renderTopBar() {
    // render sorting
    let sorting = this.data.products.sorting;
    let self = this;
    if (sorting && sorting.length) {
      // desktop top bar
      let sortingHtml = `<li class="custom-select__option flex items-center js-option" id="products-sort-by-opt-0" role="option" aria-selected="${this.currentSort.length == 0 || this.currentSort[0] == 'most-popular'}" data-value="most-popular">
          <span class="pointer-events-none">${window.theme.strings.mostPopular}</span>
        </li>`;
      let sortingMobileHtml = `<li>
          <input type="radio" class="checkbox js-drawer-sort-by" id="filter-sort-0" name="sort_by" value="most-popular" ${this.currentSort.length == 0 || this.currentSort[0] == 'most-popular' ? 'checked': ''}>
          <label for="filter-sort-0" class="flex items-start w-full m-0">
            <span class="flex-auto">${window.theme.strings.mostPopular}</span>
          </label>
        </li>`;
      let selectedSorting = sorting.find(item => item.ascending?.selected || item.descending?.selected);
      let sortCount = 1;
      let selectedSortId = '';
      let defaultSortId = '';
      sorting.forEach(function (item) {
        if (item.ascending?.query && item.settings?.ascendingText) {
          sortingHtml += `<li class="custom-select__option flex items-center js-option" id="products-sort-by-opt-${sortCount}" role="option" aria-selected="${item.ascending?.selected}" data-value="${item.ascending.query}">
              <span class="pointer-events-none">${item.settings.ascendingText}</span>
            </li>`;
          sortingMobileHtml += `<li>
              <input type="radio" class="checkbox js-drawer-sort-by" id="filter-sort-${sortCount}" name="sort_by" value="${item.ascending.query}" ${item.ascending?.selected ? 'checked' : ''}>
              <label for="filter-sort-${sortCount}" class="flex items-start w-full m-0">
                <span class="flex-auto">${item.settings.ascendingText}</span>
              </label>
            </li>`;
          sortCount++;
          if (item.ascending?.selected) {
            selectedSortId = `products-sort-by-opt-${sortCount}`;
          } else if (item.ascending?.query == self.defaultSort) {
            defaultSortId = `products-sort-by-opt-${sortCount}`;
          }
        }
        if (item.descending?.query && item.settings?.descendingText) {
          sortingHtml += `<li class="custom-select__option flex items-center js-option" id="products-sort-by-opt-${sortCount}" role="option" aria-selected="${item.descending?.selected}" data-value="${item.descending.query}">
            <span class="pointer-events-none">${item.settings.descendingText}</span>
          </li>`;
          sortingMobileHtml += `<li>
              <input type="radio" class="checkbox js-drawer-sort-by" id="filter-sort-${sortCount}" name="sort_by" value="${item.descending.query}" ${item.descending?.selected ? 'checked' : ''}>
              <label for="filter-sort-${sortCount}" class="flex items-start w-full m-0">
                <span class="flex-auto">${item.settings.descendingText}</span>
              </label>
            </li>`;
          sortCount++;
          if (item.descending?.selected) {
            selectedSortId = `products-sort-by-opt-${sortCount}`;
          } else if (item.descending?.query == self.defaultSort) {
            defaultSortId = `products-sort-by-opt-${sortCount}`;
          }
        }
      });
      if (sortingHtml) {
        this.querySelector('.hr-collection-sort-value').innerHTML = sortingHtml;
      }
      if (selectedSorting) {
        this.querySelector('#hr-collection-sort-value').innerHTML = selectedSorting.ascending?.selected ? selectedSorting.settings.ascendingText : selectedSorting.settings.descendingText;
        this.querySelector('.hr-collection-sort-value').setAttribute('aria-activedescendant', selectedSortId);
      } else {
        if (this.currentSort.length && this.currentSort[0] == 'most-popular') {
          this.querySelector('#hr-collection-sort-value').innerHTML = window.theme.strings.mostPopular;
          this.querySelector('.hr-collection-sort-value').setAttribute('aria-activedescendant', 'products-sort-by-opt-0');
        } else {
          // default sort
          let sortDefault = sorting.find(item => item.ascending?.query == this.defaultSort || item.descending?.query == this.defaultSort);
          // if ascending query is default sort, return ascendingText, else return descendingText
          if (sortDefault) {
            let sortDefaultTitle = sortDefault.ascending?.query == this.defaultSort ? sortDefault.settings.ascendingText : sortDefault.settings.descendingText;
            this.querySelector('#hr-collection-sort-value').innerHTML = sortDefaultTitle;
            this.querySelector('.hr-collection-sort-value').setAttribute('aria-activedescendant', defaultSortId);
          } else {
            // set popular as default
            this.querySelector('#hr-collection-sort-value').innerHTML = window.theme.strings.mostPopular;
            this.querySelector('.hr-collection-sort-value').setAttribute('aria-activedescendant', 'products-sort-by-opt-0');
          }
        }
      }

      // mobile inside drawer
      if (sortingMobileHtml) {
        this.querySelector('details[data-type="sort"] .filter__content ul').innerHTML = sortingMobileHtml;
      }
    }
  }

  _paginationHandler() {
    this.addEventListener('click', (event) => {
      if (event.target.closest('.hr-collection__pagination .pagination__item')) {
        event.preventDefault();
        event.target.closest('.hr-collection__pagination .pagination__item').classList.add('loading');
        let direction = event.target.closest('.hr-collection__pagination .pagination__item').getAttribute('rel');
        if (direction == 'prev') {
          this.page--;
          if (this.page < 1) {
            this.page = 1;
          }
        } else if (direction == 'next') {
          this.page++;
        } else if (direction == 'first') {
          this.page = 1;
        } else if (direction == 'last') {
          this.page = this.numberOfPage;
        }
        this._isFetchingMoreProducts = true;
        this.isFirstLoad = false;
        this.paginationChange = true;
        this._request();
      } else if (event.target.closest('.hr-collection__pagination .pagination-input')) {
        let inputWrapper = event.target.closest('.hr-collection__pagination .pagination-input');
        inputWrapper.querySelector('input').classList.remove('hidden');
        inputWrapper.querySelector('span').classList.add('hidden');
        inputWrapper.querySelector('input').focus();
      } else {
        let inputWrapper = this.querySelector('.hr-collection__pagination .pagination-input');
        if (inputWrapper) {
          inputWrapper.querySelector('input').classList.add('hidden');
          inputWrapper.querySelector('span').classList.remove('hidden');
        }
      }
    });

    this.addEventListener('change', (event) => {
      if (event.target.closest('.hr-collection__pagination .pagination-input input')) {
        let inputValue = parseInt(event.target.closest('.hr-collection__pagination .pagination-input input').value);
        if (inputValue > 0 && inputValue <= this.numberOfPage) {
          this.page = inputValue;
          this._isFetchingMoreProducts = true;
          this.isFirstLoad = false;
          this._request();
        }
      }
    });
  }

  _filterInputHandler() {
    const collectionTemplateName = document.getElementById('collection-template-name')?.dataset.template;

    this.addEventListener('change', (event) => {
      if (event.target.closest('.main-products-grid__filters .hr-facet-list input[type="checkbox"]')) {
        let currentHrFacet = event.target.closest('[data-hr-facet]')?.getAttribute('data-hr-facet')
        if (currentHrFacet) {
          window.currentHrFacet = currentHrFacet;
        }
        if (event.target.closest('.main-products-grid__filters .hr-facet-list input[type="checkbox"]').checked) {
          this.currentFilters.push(event.target.closest('.main-products-grid__filters .hr-facet-list input[type="checkbox"]').value);
        } else {
          this.currentFilters = this.currentFilters.filter(item => item !== event.target.closest('.main-products-grid__filters .hr-facet-list input[type="checkbox"]').value);
        }
        this.isFirstLoad = false;
        this.page = 1;
        this._request('desktop');
      } else if (event.target.closest('.main-products-grid__filters input[type="radio"][name="sort_by"]')) {
        let selectingSortValue = event.target.closest('.main-products-grid__filters input[type="radio"][name="sort_by"]').value;

        this.currentSort = [selectingSortValue];
        if (selectingSortValue == 'extraData.PIMsort asc' || selectingSortValue == 'created desc') {
          this.currentSort.push('extraData.sortOnTitle asc');
        }

        this.isFirstLoad = false;
        this._request('desktop');
      } else if (event.target.closest('.hr-facet-price .field-price-min') || event.target.closest('.hr-facet-price .field-price-max')) {
        if (collectionTemplateName != 'giftfinder') {
          return;
        }

        let currentHrFacet = event.target.closest('[data-hr-facet]')?.getAttribute('data-hr-facet')
        if (currentHrFacet) {
          window.currentHrFacet = currentHrFacet;
        }

        let priceWrapper = this.querySelector(this.selector.filtersWrapper);
        if (priceWrapper.querySelector('.hr-facet-price .field-price-min') && priceWrapper.querySelector('.hr-facet-price .field-price-max')) {
          // let priceMin = parseInt(priceWrapper.querySelector('.field-price-min').getAttribute('min'));
          let priceMax = parseInt(priceWrapper.querySelector('.field-price-max').getAttribute('max'));
          let priceMinSelected = priceWrapper.querySelector('.field-price-min').value;
          let priceMaxSelected = priceWrapper.querySelector('.field-price-max').value;
          this.currentFilters = this.currentFilters.filter(item => !item.includes('price:'));
          if (priceMinSelected > 0 || priceMaxSelected < priceMax) {
            // remove any item inside currentFilters that contain price
            this.currentFilters.push(`price:${priceMinSelected},${priceMaxSelected}`);
          }
        }
        this.isFirstLoad = false;
        this.page = 1;
        this._request('desktop');
      }
    });

    // filter when submit price range
    this.addEventListener('click', (event) => {
      if (event.target.closest('.main-products-grid__filters .hr-price-submit')) {
        event.preventDefault();
        let currentHrFacet = event.target.closest('[data-hr-facet]')?.getAttribute('data-hr-facet')
        if (currentHrFacet) {
          window.currentHrFacet = currentHrFacet;
        }

        let priceWrapper = this.querySelector(this.selector.filtersWrapper);
        if (priceWrapper.querySelector('.hr-facet-price .field-price-min') && priceWrapper.querySelector('.hr-facet-price .field-price-max')) {
          // let priceMin = parseInt(priceWrapper.querySelector('.field-price-min').getAttribute('min'));
          let priceMax = parseInt(priceWrapper.querySelector('.field-price-max').getAttribute('max'));
          let priceMinSelected = priceWrapper.querySelector('.field-price-min').value;
          let priceMaxSelected = priceWrapper.querySelector('.field-price-max').value;
          this.currentFilters = this.currentFilters.filter(item => !item.includes('price:'));
          if (priceMinSelected > 0 || priceMaxSelected < priceMax) {
            // remove any item inside currentFilters that contain price
            this.currentFilters.push(`price:${priceMinSelected},${priceMaxSelected}`);
          }
        }
        this.isFirstLoad = false;
        this.page = 1;
        this._request('desktop');
      };
    });
  }

  _sortingHandler() {
    this.addEventListener('click', (event) => {
      if (event.target.closest('.hr-collection-sort-value .custom-select__option')) {
        event.preventDefault();
        event.target.closest('.hr-collection-sort-value').querySelectorAll('.custom-select__option').forEach(function (item) {
          item.setAttribute('aria-selected', 'false');
        });
        event.target.closest('.hr-collection-sort-value .custom-select__option').setAttribute('aria-selected', 'true');
        let selectingSortValue = event.target.closest('.hr-collection-sort-value .custom-select__option').getAttribute('data-value');
        this.currentSort = [selectingSortValue];
        if (selectingSortValue == 'extraData.PIMsort asc' || selectingSortValue == 'created desc') {
          this.currentSort.push('extraData.sortOnTitle asc');
        }

        this.isFirstLoad = false;
        this._request('desktop');
      };
    });
  }

  _currentFacetHandler() {
    this.addEventListener('click', (event) => {
      if (event.target.closest('.facet-clear-all')) {
        event.preventDefault();
        event.stopPropagation();
        this.currentFilters = [];
        // this.currentSort = [];
        let selectingSortValue = document.querySelector('.hr-collection-sort-value .custom-select__option[aria-selected="true"]').getAttribute('data-value');
        this.currentSort = [selectingSortValue];
        if (selectingSortValue == 'extraData.PIMsort asc' || selectingSortValue == 'created desc') {
          this.currentSort.push('extraData.sortOnTitle asc');
        }
        this.isFirstLoad = false;
        this.page = 1;

        // close all filter on mobile
        if (window.innerWidth < 768) {
          this.mobileOpeningFilters = [];
          window.currentHrFacet = '';
          this.querySelectorAll('.hr-facet-list .filter.disclosure[open]').forEach(function (item) {
            item.removeAttribute('open');
          });
        }
        this._request('desktop');
      } else if (event.target.closest('.active-filter')) {
        event.preventDefault();
        this.isFirstLoad = false;
        let filterName = event.target.closest('.active-filter').getAttribute('data-filter-name');
        if (filterName == 'price') {
          this.currentFilters = this.currentFilters.filter(item => !item.includes('price:'));
        } else {
          let value = event.target.closest('.active-filter').getAttribute('value');
          this.currentFilters = this.currentFilters.filter(item => item !== value);
        }

        this._request('desktop');
      } else if (event.target.closest('.facet-clear')) {
        const hrFacetElement = event.target.closest('[data-hr-facet]');
        const dataHrFacet = hrFacetElement.getAttribute('data-hr-facet');
        const hrFacetKeysAttr = hrFacetElement.getAttribute('data-hr-facet-keys');

        if (hrFacetKeysAttr) {
          const hrFacetKeys = JSON.parse(hrFacetKeysAttr);
          this.currentFilters = this.currentFilters.filter(item => {
            return !hrFacetKeys.some(key => item.includes(key));
          });
        } else {
          this.currentFilters = this.currentFilters.filter(item => {
            return !item.includes(dataHrFacet);
          });
        }

        this.isFirstLoad = false;
        this.page = 1;
        this._request('desktop');
      }
    });
  }

  _showMoreHandler() {
    this.addEventListener('click', (event) => {
      if (event.target.closest('.size-age-group-show-more')) {
        event.preventDefault();
        const showMoreButton = event.target.closest('.size-age-group-show-more');
        const groupIndex = showMoreButton.getAttribute('data-size-age-group-index');
        const sizeAgeFilterKey = showMoreButton.getAttribute('data-size-age-filter-key');
        const filterContent = showMoreButton.closest('.filter__content');
        window.currentSizeAgeShowMoreGroups = window.currentSizeAgeShowMoreGroups || [];
        if (sizeAgeFilterKey && !window.currentSizeAgeShowMoreGroups.includes(sizeAgeFilterKey)) {
          window.currentSizeAgeShowMoreGroups.push(sizeAgeFilterKey);
        }
        filterContent.querySelectorAll(`li[data-size-age-group-index="${groupIndex}"]`).forEach(function (item) {
          item.classList.remove('hidden');
        });
        showMoreButton.classList.add('hidden');
        filterContent.querySelector(`.size-age-group-show-less[data-size-age-group-index="${groupIndex}"]`)?.classList.remove('hidden');
      }
      if (event.target.closest('.size-age-group-show-less')) {
        event.preventDefault();
        const showLessButton = event.target.closest('.size-age-group-show-less');
        const groupIndex = showLessButton.getAttribute('data-size-age-group-index');
        const sizeAgeFilterKey = showLessButton.getAttribute('data-size-age-filter-key');
        const filterContent = showLessButton.closest('.filter__content');
        window.currentSizeAgeShowMoreGroups = window.currentSizeAgeShowMoreGroups || [];
        if (sizeAgeFilterKey && window.currentSizeAgeShowMoreGroups.includes(sizeAgeFilterKey)) {
          window.currentSizeAgeShowMoreGroups.splice(window.currentSizeAgeShowMoreGroups.indexOf(sizeAgeFilterKey), 1);
        }
        filterContent.querySelectorAll(`li[data-size-age-group-index="${groupIndex}"]`).forEach(function (item, index) {
          if (index >= 5) {
            item.classList.add('hidden');
          }
        });
        showLessButton.classList.add('hidden');
        filterContent.querySelector(`.size-age-group-show-more[data-size-age-group-index="${groupIndex}"]`)?.classList.remove('hidden');
      }
      if (event.target.closest('.facet-show-more')) {
        event.preventDefault();
        event.target.closest('.facet-show-more').classList.add('hidden');
        if (event.target.closest('.filter__content').querySelector('.checkbox-list')) {
          window.currentShowMoreTabs = window.currentShowMoreTabs || [];
          window.currentShowMoreTabs.push(event.target.closest('.hr-facet-list').getAttribute('data-hr-facet'));
          event.target.closest('.filter__content').querySelector('.checkbox-list').classList.remove('short-list');
          event.target.closest('.filter__content').querySelector('.checkbox-list').classList.add('full-list');
          event.target.closest('.filter__content').querySelector('.facet-show-less').classList.remove('hidden');
        }
      }
      if (event.target.closest('.facet-show-less')) {
        event.preventDefault();
        event.target.closest('.facet-show-less').classList.add('hidden');
        if (event.target.closest('.filter__content').querySelector('.checkbox-list')) {
          window.currentShowMoreTabs = window.currentShowMoreTabs || [];
          window.currentShowMoreTabs.splice(window.currentShowMoreTabs.indexOf(event.target.closest('.hr-facet-list').getAttribute('data-hr-facet')), 1);
          event.target.closest('.filter__content').querySelector('.checkbox-list').classList.add('short-list');
          event.target.closest('.filter__content').querySelector('.checkbox-list').classList.remove('full-list');
          event.target.closest('.filter__content').querySelector('.facet-show-more').classList.remove('hidden');
        }
      }
    });
  }

  _searchHandler() {
    this.addEventListener('input', debounce((event) => {
      if (event.target.closest('.facet-search')) {
        let searchValue = event.target.closest('.facet-search').value;
        window.currentCollectionHrSearchValue = searchValue;
        window.currentCollectionHrContainer = event.target.closest('[data-hr-facet]')?.getAttribute('data-hr-facet');
        const facetContainer = event.target.closest('[data-hr-facet]');
        let checkboxList = facetContainer?.querySelector('.checkbox-list');
        if (checkboxList) {
          checkboxList.querySelectorAll('li').forEach(function (item) {
            let title = item.querySelector('.filter__title').textContent;
            if (title.toLowerCase().includes(searchValue.toLowerCase())) {
              item.classList.remove('hidden');
            } else {
              item.classList.add('hidden');
            }
          });
          // it is conflicting with showMoreHandler, so we need to avoid it
          if (checkboxList.classList.contains('short-list')) {
            checkboxList.classList.remove('short-list');
            checkboxList.closest('.filter__content').querySelector('.facet-show-more').classList.add('hidden');
            checkboxList.closest('.filter__content').querySelector('.facet-show-less').classList.add('hidden');
          }
          checkboxList.querySelectorAll('summary').forEach(function (item) {
            item.classList.add('hidden');
          });
          checkboxList.querySelectorAll('.size-age-group-show-more, .size-age-group-show-less').forEach(function (item) {
            item.classList.add('hidden');
          });
          if (searchValue && facetContainer?.getAttribute('data-hr-facet') == 'sizeAgeGroup') {
            checkboxList.querySelectorAll('summary[data-size-age-group-index]').forEach(function (item) {
              const groupIndex = item.getAttribute('data-size-age-group-index');
              const hasVisibleItems = Array.from(checkboxList.querySelectorAll(`li[data-size-age-group-index="${groupIndex}"]`)).some(function (groupItem) {
                return !groupItem.classList.contains('hidden');
              });
              if (hasVisibleItems) {
                item.classList.remove('hidden');
              }
            });
          }
          if (!searchValue) {
            checkboxList.querySelectorAll('summary').forEach(function (item) {
              item.classList.remove('hidden');
            });
            if (facetContainer?.getAttribute('data-hr-facet') == 'sizeAgeGroup' && checkboxList.querySelector('.size-age-group-show-more')) {
              const groupIndexes = new Set();
              checkboxList.querySelectorAll('[data-size-age-group-index]').forEach(function (item) {
                groupIndexes.add(item.getAttribute('data-size-age-group-index'));
              });
              groupIndexes.forEach(function (groupIndex) {
                const groupItems = checkboxList.querySelectorAll(`li[data-size-age-group-index="${groupIndex}"]`);
                const showMoreButton = checkboxList.querySelector(`.size-age-group-show-more[data-size-age-group-index="${groupIndex}"]`);
                const showLessButton = checkboxList.querySelector(`.size-age-group-show-less[data-size-age-group-index="${groupIndex}"]`);
                const sizeAgeFilterKey = showMoreButton?.getAttribute('data-size-age-filter-key') || showLessButton?.getAttribute('data-size-age-filter-key');
                const isSizeAgeGroupExpanded = window.currentSizeAgeShowMoreGroups?.includes(sizeAgeFilterKey);
                groupItems.forEach(function (item, index) {
                  if (!isSizeAgeGroupExpanded && index >= 5) {
                    item.classList.add('hidden');
                  }
                });
                if (groupItems.length > 5) {
                  if (isSizeAgeGroupExpanded) {
                    showLessButton?.classList.remove('hidden');
                  } else {
                    showMoreButton?.classList.remove('hidden');
                  }
                }
              });
              return;
            }
            // if number of items is more than threshold, then show show more button
            if (checkboxList.querySelectorAll('li').length > window.theme.settings.helloretailShowMoreOnFilterList) {
              checkboxList.classList.add('short-list');
              checkboxList.closest('.filter__content').querySelector('.facet-show-more').classList.remove('hidden');
              checkboxList.closest('.filter__content').querySelector('.facet-show-less').classList.add('hidden');
            }
          }
        }
      }
    }, 200));
  }

  _mobileDrawerHandler() {
    let self = this;
    document.querySelector('.js-close-drawer-mob').addEventListener('click', (event) => {
      setTimeout(() => {
        if (self.shouldScrollToTop) {
          if (document.querySelector('h1')) {
            document.querySelector('h1').scrollIntoView({ behavior: 'instant' });
          } else {
            self.scrollIntoView({ behavior: 'instant' });
          }
          self.shouldScrollToTop = false;
        }
      }, 500);
    });
  }

  updateOpeningFilters() {
    this.mobileOpeningFilters = [];
    this.mobileFilterScroll = 0;
    let self = this;
    this.querySelectorAll('.hr-facet-list .filter.disclosure[open]').forEach(function (item) {
      let filterName = item.closest('[data-hr-facet]')?.getAttribute('data-hr-facet');
      if (filterName && !self.mobileOpeningFilters.includes(filterName)) {
        self.mobileOpeningFilters.push(filterName);
      }
    });

    // current scroll
    if (window.innerWidth < 768) {
      this.mobileFilterScroll = this.querySelector('.main-products-grid__filters .drawer__content').scrollTop;
    }
  }

  formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }

  sizeSortKey(sizeTitle, noFallback = false) {
    const knownSizes = ["XXXS", "XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL"];
    // Match a leading "<number> cm", optionally followed by an age suffix such as
    // " / 4-5 år" (as used by the combined size/age group filter).
    const cmRegex = /^(\d+)\s?cm(\s*\/.*)?$/;

    // Check if the title is in the known sizes
    if (knownSizes.includes(sizeTitle)) {
      return { category: 0, value: knownSizes.indexOf(sizeTitle) };
    }

    // Check if the title is a number (digits, optional decimal with dot/comma) or a mixed fraction (e.g. "33 1/2")
    if (/^(?:\d+(?:[.,]\d+)?|\d+\s+\d+\/\d+)$/.test(sizeTitle)) {
      // return { category: 1, value: parseFloat(sizeTitle, 10) };

      let value;

      // If there's a space, assume it's a mixed fraction (e.g., "33 1/2")
      if (sizeTitle.includes(" ")) {
        const [wholePart, fractionPart] = sizeTitle.split(" ");
        // Replace comma with dot in the whole part in case it's a decimal like "32,5 1/2" (if that ever occurs)
        const whole = parseFloat(wholePart.replace(",", "."));
        const [numerator, denominator] = fractionPart.split("/");
        value = whole + (parseFloat(numerator) / parseFloat(denominator));
      } else {
        // Replace comma with dot for proper decimal parsing
        value = parseFloat(sizeTitle.replace(",", "."));
      }

      return { category: 1, value };
    }

    // Check if the title is a number followed by "cm"
    const cmMatch = sizeTitle.match(cmRegex);
    if (cmMatch) {
      return { category: 2, value: parseInt(cmMatch[1], 10) };
    }

    // Check if the title is an age range such as "0-1 år", "6-10 mdr" or "10+ år"
    // (used by accessory/size groups that carry ages instead of cm sizes).
    // Sort by the range's starting number; month ranges sort before year ranges.
    const ageRangeMatch = sizeTitle.match(/^(\d+)\s*(?:[-–]\s*\d+|\+)?\s*(mdr|år)$/i);
    if (ageRangeMatch) {
      const monthUnit = (window.theme?.strings?.helloretailMonthUnit || 'mdr').toLowerCase();
      const isMonth = ageRangeMatch[2].toLowerCase() === monthUnit;
      // Keep month ranges ahead of year ranges by offsetting the year values.
      const start = parseInt(ageRangeMatch[1], 10);
      return { category: 2, value: isMonth ? start : start + 1000 };
    }

    // For all other cases, treat as a string
    if (!noFallback) {
      return { category: 3, value: sizeTitle };
    } else {
      return { category: 4, value: 0 };
    }
  }

  renderGrandchildSubCollection() {
    if (document.querySelector('.hr-facet-list[data-hr-facet="extraDataList.type"]') && document.querySelector('.sub-collection-list')) {
      if (document.querySelector('.slider__item-skeleton')) {
        let haveItem = false;
        if (document.querySelectorAll('.hr-facet-list[data-hr-facet="extraDataList.type"] .checkbox-list li').length > 1) {
          document.querySelectorAll('.hr-facet-list[data-hr-facet="extraDataList.type"] .checkbox-list li').forEach(function (item) {
            let title = item.querySelector('.filter__title').textContent;
            let value = item.querySelector('input[type="checkbox"]').value;
            if (title && value) {
              let ske = document.querySelector('.slider__item-skeleton').cloneNode(true);
              ske.classList.remove('hidden');
              ske.classList.remove('slider__item-skeleton');
              ske.querySelector('.collection-card__content-wrapper').innerText = title;
              ske.querySelector('.collection-card').setAttribute('href', value);
              document.querySelector('.sub-collection-list').appendChild(ske);
              haveItem = true;
            }
          });
        } else {
          document.querySelector('.sub-collection-list').closest('.shopify-section').classList.add('hidden');
        }

        if (haveItem && document.querySelector('.sub-collection-list .slider__item-back')) {
          document.querySelector('.sub-collection-list .slider__item-back').classList.remove('hidden');
        }
        document.querySelectorAll('.slider__item-skeleton').forEach(function (item) {
          item.remove();
        });
        setTimeout(function () {
          window.dispatchEvent(new Event('refresh-sub-collections'));
          document.querySelectorAll('.sub-collection-list .collection-card').forEach(function (item) {
            item.addEventListener('click', function (event) {
              event.preventDefault();
              let href = item.getAttribute('href');
              if (href && document.querySelector(`.hr-facet-list[data-hr-facet="extraDataList.type"] input[value="${href}"]`)) {
                event.preventDefault();
                let isChecked = document.querySelector(`.hr-facet-list[data-hr-facet="extraDataList.type"] input[value="${href}"]`).checked;
                // toggle input value
                document.querySelector(`.hr-facet-list[data-hr-facet="extraDataList.type"] input[value="${href}"]`).checked = !isChecked;
                document.querySelector(`.hr-facet-list[data-hr-facet="extraDataList.type"] input[value="${href}"]`).dispatchEvent(new Event('change', { 'bubbles': true }));
                if (isChecked) {
                  item.classList.remove('active')
                } else {
                  item.classList.add('active')
                }
                
              }
            });
          });
        }, 1000);
      }
    } else {
      // hide sub collection
      document.querySelector('.sub-collection-list').closest('.shopify-section').classList.add('hidden');
    }
  }

  // _customFilterListener() {
  //   document.addEventListener('do-hr-filter', (event) => {
  //     let filters = event.detail.values;
  //     if (filters && filters.length) {
  //       this.currentRootFilters = filters;
  //       this.isFirstLoad = false;
  //       this.page = 1;
  //       this._request();
  //     }
  //   });
  // }
};
if (!window.customElements.get('hr-collection')) {
  window.customElements.define('hr-collection', HrCollection);
}
